<!-- 分享主页 -->
<template>
    <div class="homePage">
        <div v-if="isWeChat">
            <browser-open></browser-open>
        </div>
        <div v-else class="overlay">
            <div class="title">
                <span>小麦聊天室</span>
            </div>
            <div class="tip">
                <span>语音畅聊带你邂逅开黑伙伴</span>
            </div>

            <div class="img">
                <van-image fit="cover" round width="111" height="111" :src="params.avatar" />
            </div>

            <div class="text-name mbt36">
                <span>{{ params.homeOwner }}</span>
            </div>

            <div class="text-name mbt8">
                <span class="mbt8">{{ params.Introduction }}</span>

            </div>

            <div class="text-name mbt6">
                <span class="text-id">ID: {{ params.roomId }}</span>
                <span class="down-load" @click="handleCopy(params.roomId)"></span>
            </div>

            <div class="bt">
                <van-button class="ksjrBtn" @click="handleOpenApp" round type="primary">快速加入</van-button>
            </div>

        </div>
    </div>
</template>

<script>
import { getUrlParam, isWeChatBrowser } from '../../config/utils'
import { Toast } from 'vant';
import BrowserOpen from './browserOpen.vue';

export default {
    components: { BrowserOpen },
    data() {
        return {
            isWeChat: isWeChatBrowser(),
            params: {
                appLink: '',
                homeOwner: '',
                Introduction: '',
                roomId: '',
                avatar: ''
            },
            timer: ''
        }
    },
    mounted() {
        this.handleUrl()
    },
    beforeDestroy() {
        clearTimeout(this.timer)
    },
    methods: {
        handleCopy(data) {
            let oInput = document.createElement("input");
            oInput.value = data;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            Toast('复制成功')
            oInput.remove();

        },
        handleUrl() {
            if (!this.$route.query.appLink) return
            let appLink = (this.$route.query.appLink).replaceAll(' ', '+')
            this.params.appLink = this.$Base64.decode(appLink);
            this.params.roomId = getUrlParam(this.params.appLink, 'roomId');
            this.params.homeOwner = getUrlParam(this.params.appLink, 'homeOwner');
            this.params.Introduction = getUrlParam(this.params.appLink, 'Introduction');
            this.params.avatar = getUrlParam(this.params.appLink, 'avatar');
        },
        handleOpenApp() {
            if (!this.params.appLink) return;
            window.location.href = this.params.appLink;
            this.timer = setTimeout(()=>{
                if (typeof document.hidden !== "undefined") {
                    if (!document.hidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.mozHidden !== "undefined") {
                    if (!document.mozHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.msHidden !== "undefined") {
                    if (!document.msHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.webkitHidden !== "undefined") {
                    if (!document.webkitHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                }
            },2000)
        }
    }

}
</script>

<style lang="less" scoped>
.homePage {
    color: #FFFFFF;
    height: 100%;
    background: url('/imgs/homeBg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;

    .overlay {
        height: 100%;
        min-height: 812px;
        background-color: rgba(0, 0, 0, .6);
        text-align: center;
        padding-top: 70px;

        .title {
            color: #E2E4F3;
            font-family: REEJI-FlashItalicGB-Flash-Black, REEJI-FlashItalicGB-Flash;
            font-size: 30px;
            font-weight: 900;
            line-height: 54.5px;

        }

        .tip {
            font-family: MiSans-Regular, MiSans;
            color: #E2E4F3;
            font-size: 14.5px;
            font-weight: 400;
            line-height: 26px;
        }

        .img {
            margin-top: 72.5px;
            margin-bottom: 36.5px;
        }

        .text-name {
            font-family: MiSans-Medium;
            font-size: 15px;
            font-weight: bold;

            .text-id {
                font-size: 12px;
            }

            .down-load {
                background: url('/imgs/download.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                height: 12px;
                width: 12px;
                display: inline-block;
                margin-left: 5px;
            }
        }

        .mbt36 {
            margin-bottom: 36.5px;
        }

        .mbt6 {
            margin-bottom: 6px;
        }

        .mbt8 {
            margin-bottom: 8px;
        }

        .ksjrBtn {
            width: 231px;
            height: 45px;
            color: #373737;
            font-size: 15px;
            font-weight: 500;
            background: #F9EB34;
            border-color: #F9EB34;

        }

        .bt {
            margin-top: 63.5px;
        }

    }

}
</style>